import React, { Component } from 'react';

import { MultiSelectFilter, SelectTypes } from 'common/components/core/select';

class ChannelPreferenceSelectorFilter extends Component {
    onChannelSelect = ({ values, allowEmptyOrNull }) => {
        // adding logic for multi select and special handling for isNull case.
        // on clear selection
        const isEmpty = !values.length && !allowEmptyOrNull;
        this.props.onChange(isEmpty ? undefined : { values, allowEmptyOrNull });
    };

    getOptionValue = option => option.id;

    getOptionLabel = option => option.name;

    render() {
        const { value, options } = this.props;
        return (
            <MultiSelectFilter
                {...this.props}
                allowEmptyOrNull={value?.allowEmptyOrNull || false}
                disabled={!options.length}
                selectType={SelectTypes.Outline}
                value={value?.values || ''}
                getOptionValue={this.getOptionValue}
                getOptionLabel={this.getOptionLabel}
                onChange={this.onChannelSelect}
            />
        );
    }
}

export default ChannelPreferenceSelectorFilter;
